import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/layout.css";
import "./styles/negocio.css";
import "./styles/conjunto.css";
import "./styles/conjunto-2.css";
import "./styles/conjunto-3.css";
import "./styles/conjunto-4.css";
import "./styles/conjunto-5.css";

import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { ToastProvider } from "./context/ToastContext";
import { iniciarMonitoreo } from "./lib/monitoreo";

/*
 * Antes de montar nada: así un fallo durante el arranque también queda
 * registrado. Sin `VITE_SENTRY_DSN` no descarga ni ejecuta nada.
 */
iniciarMonitoreo();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Un panel de administración se deja abierto durante horas; revalidar
      // al volver a la pestaña evita decidir sobre datos viejos.
      refetchOnWindowFocus: true,
      staleTime: 30_000,
      retry: 1,
    },
  },
});

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ToastProvider>
          <AuthProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </AuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
